import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Typography } from 'antd';
import { SearchOutlined, LogoutOutlined } from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { inspectionApi } from '../../services/api';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const InspectionLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('inspection_admin');
    if (stored) {
      try { setAdmin(JSON.parse(stored)); } catch {}
    }
    // Also fetch profile
    inspectionApi.profile().then(res => {
      if (res.success) setAdmin(res.data);
    }).catch(() => {});
  }, []);

  const menuItems = [
    { key: '/inspection', icon: <SearchOutlined />, label: '货品查询' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('inspection_token');
    localStorage.removeItem('inspection_admin');
    navigate('/inspection/login');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider theme="dark" width={200}>
        <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Title level={4} style={{ color: '#fff', margin: 0 }}>国检验证</Title>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={['/inspection']}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 16 }}>
          {admin && <span>{admin.nickname || admin.username}</span>}
          <Button icon={<LogoutOutlined />} onClick={handleLogout}>退出登录</Button>
        </Header>
        <Content style={{ margin: 24 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default InspectionLayout;
